"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _keyboard = require("../../../utilities/keyboard");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Portal = function Portal(_a) {
  var _b = _a.lockBodyScroll,
      lockBodyScroll = _b === void 0 ? false : _b,
      props = (0, _tslib.__rest)(_a, ["lockBodyScroll"]);

  var _c = React.useState({
    portal: undefined
  }),
      state = _c[0],
      setState = _c[1];

  React.useEffect(function () {
    var LayerPortalNode = document.getElementById('LayerPortalNode');
    var portal = (0, _reactDom.createPortal)(props.children, LayerPortalNode); // tslint:disable-next-line

    if (typeof window !== 'undefined' && lockBodyScroll) {
      var scrollY_1 = window.scrollY + "px";
      document.body.style.top = "-" + scrollY_1;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }

    setState({
      portal: portal
    });
    return function () {
      // tslint:disable-next-line
      if (typeof window !== 'undefined' && lockBodyScroll) {
        var scrollY_2 = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, parseInt(scrollY_2 || '0', 10) * -1);
      }
    };
  }, []);
  var isEscapePressed = (0, _keyboard.useButtonKeys)().isEscapePressed;

  if (isEscapePressed) {
    props.onClose();
  }

  return React.createElement(React.Fragment, null, state.portal);
};

Portal.displayName = 'LayerPortal';
var _default = Portal;
exports.default = _default;